// import axios from 'axios';
// import constants from '../constants';
// import authService from '../auth/AuthService';
import moment from 'moment';
import { allocations } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/allocation';

export default {
  getForPeriod(startDate, endDate, teamFilter, forRegion) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}&forRegion=${(forRegion ? forRegion : '')}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getAggregate: (startDate, endDate, teamFilter, forRegion) => AppUsersClient.get(`${resource}/aggregate`, {
    params: {
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
      forTeam: teamFilter ? teamFilter : '',
      forRegion: forRegion ? forRegion : ''
    }
  }),
  getForParent: (allocationId) => AppUsersClient.get(`${resource}/byParentId/${allocationId}`),
  getMyAllocations(startDate, endDate, asEmployee) {
    return new Promise(function(resolve, reject) {
      const asEmployeeParam = (asEmployee) ? `&asEmployee=${asEmployee}` : '';
      AppUsersClient.get(`${resource}/getMyAllocations/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}${asEmployeeParam}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getAllocationDashboard(region) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/getAllocationDashboard/?region=${(region ? region : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getTimeOff(fromDate, forGroup) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/getTimeOff/?fromdate=${moment(fromDate).format('YYYY-MM-DD')}&forGroup=${(forGroup ? forGroup : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  create(
    allocationType,
    circleId,
    employeeId,
    startDate,
    allocationSpanInDays, 
    groupId) {
      return new Promise(function(resolve, reject) {        
        AppUsersClient.post(`${resource}`, {
          allocationType: allocationType,
          circleId: circleId,
          employeeId: employeeId,
          startDate: startDate,
          allocationSpanInDays: allocationSpanInDays,
          groupId: groupId
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  update(allocation) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(`${resource}`, allocation)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(allocationId, updateTag) {    
    return new Promise(function(resolve, reject) {      
      AppUsersClient.delete(`${resource}/${allocationId}?updateTag=${updateTag}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  split(allocation) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(`${resource}/split`, allocation)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getReplacementAllocationsCurrentWeek: () => AppUsersClient.get(`${resource}/replacementallocationscurrentweek`),
  // Get's allocation for my calendar for at given date and group
  getAllocationForGroupOnDate(date, forGroup, asEmployee) {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    const asEmployeeParam = (asEmployee) ? `&asEmployee=${asEmployee}` : '';
    
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/getAllocationForGroupOnDate/?fromdate=${formattedDate}&forUser=${(forGroup ? forGroup : '')}${asEmployeeParam}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
};
